import setFullbanner from './home/fullbanner';
import setCarousel from '../components/carousel';
import setInstagram from './home/instagram';
import Reviews from '../components/reviews';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  swipersHome: function () {
    try {
      //Quando a página carrega seleciona o primeiro swiper da lista
      loadProductSwiper(1);

      //Adiciona evento Click nos links
      $('.swiper-master .links a').on('click', function (e) {
        e.preventDefault();
        $('.swiper-master .links a').removeClass('-active');
        $(this).addClass('-active');
        var tag = $(this).attr('href');
        $('.swiper-home-produtos').removeClass('active');
        $('[data-link="' + tag + '"]').addClass('active');
        var val = $(this).attr('value');

        //Instancia o swiper de acordo com o index selecionado
        loadProductSwiper(val);
      });

      //Instancia dinamicamente o swiper selecionado
      function loadProductSwiper(index) {
        var swiperHomeProdutos = new Swiper(`.swiper-home-produtos-${index}`, {
            direction: 'horizontal',
            slidesPerView: 1.25,
            spaceBetween: 10,
            watchOverflow: true,
            loop: false,
            navigation: {
              nextEl: '.home-produtos .swiper-button-next',
              prevEl: '.home-produtos .swiper-button-prev',
            },
            pagination: {
              el: '.home-produtos .swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
            breakpoints: {
              0: {
                centeredSlides: false,
              },
              '@0.75': {
                slidesPerView: 1.25,              
              },
              '@1.00': {
                slidesPerView: 2,
              },
              '@1.20': {
                slidesPerView: 4,
                centeredSlides: false
              },
              '@1.50': {
                slidesPerView: 4,
              },
            },
          }
        );
      }
    } catch (error) {
      /*LOG DEV  */
      //console.log(`${error}`);
      /*LOG PROD */
      //console.log(`ação inesperada em store home:swipersHome`);
    }
  },
  init: function () {
    setFullbanner();
    handleConditionalLazy();
    this.swipersHome();
    setCarousel();
    Reviews.init();
    setInstagram();
//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init()
})
